import EmberRouter from '@embroider/router';
import config from 'bcl/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('login');
  this.route('auth', { path: '' }, function () {
    this.route('basic-data', function () {
      this.route('item', { path: 'item/:id' });
      this.route('location', { path: 'location/:id' });
      this.route('supplier', { path: 'supplier/:id' });
    });
    this.route('overview');
    this.route('location');
    this.route('stocktaking', { path: 'stocktaking/:id' }, function () {
      this.route('name', { path: '/:name' });
    });
    this.route('orders', function () {
      this.route('edit', { path: 'edit/:id' });
      this.route('new');
      this.route('accept', { path: 'accept/:id' });
      this.route('show', { path: 'show/:id' });
    });
    this.route('admin');

    this.route('views', function() {
      this.route('proposed');
      this.route('suppliers');
    });
  });
  this.route('register');
});
